/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { IToolbeltFacade } from '@hcworkspace/sysque/toolbelt/data-access';
import { Store } from '@ngrx/store';
import { getProcessFittingStatus, sendPopupRoutingAction } from '../toolbelt.actions';
import { BackendService, DataInitializerService, LocalStorageService } from '../../../../../../../sysque/toolbelt/utils/src';
import { Observable, from } from 'rxjs';
import { selectProcessFittStatus } from '../tool-belt.selector';
import { BooleanObject } from '../../models/boolean-object';
import { RotateElementReturnCodes } from '../../../../../../shared/ui/src/lib/enums/rotate-element-return-codes';
import { ShiftSegmentReturnCodes } from '../../../../../../shared/ui/src/lib/enums/shift-segment-return-codes';
import { GlobalConstants } from '../../constants/global-constants';
import { ShiftElementDirections } from 'libs/sysque/shared/ui/src/lib/enums/shift-segment-directions';
import { RotateElementDirection } from '../../models/rotate-element-direction';

@Injectable({ providedIn: 'root' })
export class ToolbeltFacade implements IToolbeltFacade {
  constructor(
    public store: Store,
    public backendService: BackendService,
    private localStorageService: LocalStorageService,
    private service: DataInitializerService
  ) {}

  public updateDispatchLocalStorage(key: string, value: any): void {
    this.localStorageService.updateDispatchLocalStorage(key, value);
  }

  updateLocalStorage(key: string, value: any) {
    this.localStorageService.updateDispatchLocalStorage(key, value);
  }

  getLocalStorage(key: string) {
    return this.localStorageService.getStorage(key);
  }

  sendPopupRoutingWpfDialogs(itemName: string, selectedSystemName: string): void {
    this.backendService.messageHandler.sendRequestAsync(GlobalConstants.HandleWpfDialogs, [
      itemName,
      selectedSystemName,
    ]);
  }

  sendPopupRoutingAction(itemName: any, width: number, height: number): void {
    this.store.dispatch(sendPopupRoutingAction({ route: itemName, width: width, height: height }));
  }

  sendPopupRoutingNoDialogs(itemName: string, selectedSystemName: string, selectedCategory: string): void {
    this.backendService.messageHandler.sendRequestAsync(GlobalConstants.HandleCommandsWithNoDialogs, [itemName, selectedSystemName, selectedCategory]);
  }

  sendRequest(message: string) {
    return this.backendService.messageHandler.sendRequestAsync(message);
  }

  getProcessStatus() {
    this.store.dispatch(getProcessFittingStatus());
  }

  selectProcessFitting(): Observable<BooleanObject> {
    return this.store.select(selectProcessFittStatus) as Observable<BooleanObject>;
  }

  public rotateElement(
    rotateValue: number,
    rotateDirection: RotateElementDirection
  ): Observable<RotateElementReturnCodes> {
    return from<Promise<RotateElementReturnCodes>>(
      this.backendService.messageHandler.sendRequestAsync(GlobalConstants.RotateElement, [rotateValue, rotateDirection])
    );
  }

  public shiftElement(shiftDirection: ShiftElementDirections): Observable<ShiftSegmentReturnCodes> {
    return from<Promise<ShiftSegmentReturnCodes>>(
      this.backendService.messageHandler.sendRequestAsync(GlobalConstants.ShiftSegment, [shiftDirection])
    );
  }

  public processEnable(isEnabled: boolean): Observable<void> {
    return from<Promise<void>>(this.backendService.messageHandler.sendRequestAsync(GlobalConstants.ProcessEnable, [isEnabled]));
  }

  public updateOnlyFitting(categoryName: string, isChecked: boolean): void {
    if (categoryName === undefined || isChecked === undefined || categoryName === null || isChecked === null) {
      return;
    }
    this.service.onProcessFittingsOnly(categoryName, isChecked);
  }

  public showNonStandard(isShowNonStandard: boolean): Observable<boolean> {
    return from<Promise<boolean>>(
      this.backendService.messageHandler.sendRequestAsync(GlobalConstants.ShowNonStandardCall, [isShowNonStandard])
    );
  }
}
